var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPremiumFaded({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73152 0.905826C4.01384 0.350676 4.59095 0 5.22223 0H24.7778C25.4091 0 25.9862 0.350676 26.2685 0.905826L29.824 7.89742C30.1202 8.47973 30.0376 9.17916 29.6137 9.67929L16.2804 25.4104C15.9637 25.784 15.4946 26 15 26C14.5054 26 14.0363 25.784 13.7196 25.4104L0.386316 9.67929C-0.03759 9.17916 -0.120155 8.47973 0.175973 7.89742L3.73152 0.905826ZM6.25229 3.27731L3.64487 8.40452L15 21.8017L26.3551 8.40452L23.7477 3.27731H6.25229Z",
    fill: "#F4BB27",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66673 8.63068C8.66673 7.72567 9.41292 6.99202 10.3334 6.99202H19.6667C20.5872 6.99202 21.3334 7.72567 21.3334 8.63068C21.3334 9.53568 20.5872 10.2693 19.6667 10.2693H10.3334C9.41292 10.2693 8.66673 9.53568 8.66673 8.63068Z",
    fill: "#F4BB27",
    fillOpacity: 0.4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumFaded);
export default __webpack_public_path__ + "static/media/PremiumFaded.023486fa.svg";
export { ForwardRef as ReactComponent };